const abs = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const air_conditioner = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const alarm = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const central_lock = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const rims = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const checkup = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí, en la marca'
  },
  {
    id: 2,
    name: 'Sí, no en la marca'
  }
];
const airbags_number = [
  {
    id: 0,
    name: '0'
  },
  {
    id: 1,
    name: '1'
  },
  {
    id: 5,
    name: '2'
  },
  {
    id: 6,
    name: '3'
  },
  {
    id: 7,
    name: '4'
  },
  {
    id: 8,
    name: '5'
  },
  {
    id: 9,
    name: '6'
  },
  {
    id: 10,
    name: '7'
  },
  {
    id: 2,
    name: '8'
  },
  {
    id: 3,
    name: '9'
  },
  {
    id: 4,
    name: '10 o más'
  }
];
const doors_number = [
  {
    id: 0,
    name: '2 + Maleta'
  },
  {
    id: 1,
    name: '3 + Maleta'
  },
  {
    id: 2,
    name: '4 + Maleta'
  }
];

const circulation_permit = [
  {
    id: 0,
    name: 'No'
  },
  /*{
    id: 7,
    name: 'Sí, 2020 1ra cuota'
  },
  {
    id: 8,
    name: 'Sí, 2020 año completo'
  },
  {
    id: 9,
    name: 'Sí, 2021 1ra cuota'
  },
  {
    id: 10,
    name: 'Sí, 2021 año completo'
  },
  {
    id: 11,
    name: 'Sí, 2022 1ra cuota'
  },
  {
    id: 12,
    name: 'Sí, 2022 año completo'
  },
  {
    id: 13,
    name: 'Sí, 2023 1ra cuota'
  },
  {
    id: 14,
    name: 'Sí, 2023 año completo'
  },
  */
  {
    id: 15,
    name: 'Sí, 2024 1ra cuota'
  },
  {
    id: 16,
    name: 'Sí, 2024 año completo'
  },
  {
    id: 17,
    name: 'Sí, 2025 1ra cuota'
  },
  {
    id: 18,
    name: 'Sí, 2025 año completo'
  }
];

const inspection = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const sun_roof = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];
const tapestry = [
  {
    id: 0,
    name: 'Tela'
  },
  {
    id: 1,
    name: 'Cuero'
  },
  {
    id: 2,
    name: 'Cuero Sintético'
  },
  {
    id: 3,
    name: 'Otro'
  }
];

const vehicle_type = [
  {
    id: 0,
    name: 'Sedán'
  },
  {
    id: 1,
    name: 'Hatchback'
  },
  {
    id: 2,
    name: 'SUV'
  },
  {
    id: 3,
    name: 'Coupé'
  },
  {
    id: 4,
    name: 'Cabina Simple'
  },
  {
    id: 5,
    name: 'DobleCabina'
  },
  {
    id: 6,
    name: 'Station Wagon'
  },
  {
    id: 7,
    name: 'Otro'
  }
];

const type = vehicle_type;

const traction = [
  {
    id: 0,
    name: '4x2'
  },
  {
    id: 1,
    name: '4x4'
  }
];

const transmission = [
  {
    id: 0,
    name: 'Mecánico'
  },
  {
    id: 1,
    name: 'Automático'
  }
];

const collateral = [
  {
    id: 0,
    name: 'Sí, sin información'
  },
  {
    id: 1,
    name: 'No'
  },
  {
    id: 2,
    name: 'Crediautos'
  },
  {
    id: 3,
    name: 'KSF'
  },
  {
    id: 4,
    name: 'Otra'
  },
  {
    id: 5,
    name: 'CHSG'
  },
  {
    id: 6,
    name: 'Santander'
  },
  {
    id: 7,
    name: 'BCP'
  },
  {
    id: 8,
    name: 'Interbank'
  },
  {
    id: 9,
    name: 'Scotiabank'
  },
  {
    id: 10,
    name: 'BBVA Continental'
  },
  {
    id: 11,
    name: 'GMAC'
  },
  {
    id: 12,
    name: 'Forum'
  },
  {
    id: 13,
    name: 'Amicar'
  },
  {
    id: 14,
    name: 'Tanner'
  }
];

const owners_number = [
  {
    id: 0,
    name: '1'
  },
  {
    id: 1,
    name: '2'
  },
  {
    id: 2,
    name: '3'
  },
  {
    id: 3,
    name: '4 o màs'
  }
];

const fuel_type = [
  {
    id: 0,
    name: 'Bencina'
  },
  {
    id: 1,
    name: 'Diesel'
  },
  {
    id: 2,
    name: 'Híbrido'
  },
  {
    id: 3,
    name: 'Eléctrico'
  }
];

const seat_runs = [
  {
    id: 0,
    name: '1'
  },
  {
    id: 1,
    name: '2'
  },
  {
    id: 2,
    name: '3'
  }
];

const steering = [
  {
    id: 0,
    name: 'Asistida'
  },
  {
    id: 1,
    name: 'Hidráulica'
  },
  {
    id: 2,
    name: 'Eléctrica'
  },
  {
    id: 3,
    name: 'Mecánica'
  }
];

const soat = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];

const key_spare = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  },
  {
    id: 2,
    name: 'Sin información'
  }
];

const condition = [
  {
    id: 0,
    name: 'Excelente'
  },
  {
    id: 1,
    name: 'Buena'
  },
  {
    id: 2,
    name: 'Regular'
  },
  {
    id: 3,
    name: 'Sin Revisar'
  }
];

const funding = [
  {
    id: 0,
    name: 'Sin financiamiento'
  },
  {
    id: 1,
    name: 'Con financiamiento'
  },
  {
    id: 2,
    name: 'Compra inteligente'
  }
];

const vehicle_status = [
  {
    id: 0,
    name: 'Usado'
  },
  {
    id: 1,
    name: 'Nuevo'
  }
];

const renewal = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];

const vehicle_has_stock = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];

const options_condition = [
  { value: '0', label: 'Excelente', msg: 'Se ve nuevo y parece estar en perfecta condición mecánica.' },
  { value: '1', label: 'Buena', msg: 'Tiene algunos defectos estéticos pero no parece tener problemas mecánicos considerables' },
  { value: '2', label: 'Regular', msg: 'Tiene defectos estéticos y/o mecánicos que requieren reparación.' },
  { value: '3', label: 'Sin Revisar', msg: '' }
];

const acObject = { 0: 'No', 1: 'Sí' };
const transmissionObject = { 0: 'Mecánico', 1: 'Automático' };
// const tapestryObject = {
//   0: 'Tela',
//   1: 'Cuero',
//   2: 'Cuero Sintético',
//   3: 'Otro'
// };
const tractionObject = {
  0: '4x2',
  1: '4x4'
};

const vehicle_inspection = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];

const gas_convertion = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'GLP'
  },
  {
    id: 2,
    name: 'GNV'
  }
];

const additional_fields = [
  'condition',
  'key_spare',
  'owners_number',
  'vehicle_inspection',
  'checkup',
  'renewal',
  'circulation_permit',
  'funding',
  'vehicle_status',
  'collateral',
  'soat',
  'zofri',
  'billable',
  'brand_guarantee'
];
const equipment_fields = [
  'abs',
  'air_conditioner',
  'alarm',
  'central_lock',
  'rims',
  'tapestry',
  'vehicle_type',
  'sun_roof',
  'transmission',
  'traction',
  'airbags_number',
  'doors_number',
  'steering',
  'seat_runs',
  'fuel_type'
];
const zofri = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];

const billable = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'Sí'
  }
];

const brand_guarantee = [
  { id: 0, name: 'Expirada' },
  {
    id: 1,
    name: 'Válida'
  }
];
export const trays = { retake_letter: 'Carta de toma', inspection: 'Peritaje', inspectionFinished: 'Peritaje completado' };

const vehicle = {
  abs,
  air_conditioner,
  alarm,
  central_lock,
  rims,
  checkup,
  condition,
  key_spare,
  steering,
  seat_runs,
  fuel_type,
  owners_number,
  collateral,
  transmission,
  traction,
  airbags_number,
  circulation_permit,
  doors_number,
  inspection,
  sun_roof,
  type,
  tapestry,
  funding,
  vehicle_status,
  options_condition,
  renewal,
  acObject,
  transmissionObject,
  //tapestryObject,
  tractionObject,
  additional_fields,
  equipment_fields,
  vehicle_type,
  vehicle_inspection,
  vehicle_has_stock,
  soat,
  zofri,
  trays,
  billable,
  gas_convertion,
  brand_guarantee
};

export default vehicle;
